import { render, staticRenderFns } from "./ReviewsFilterChip.vue?vue&type=template&id=7e1d7068&"
import script from "./ReviewsFilterChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewsFilterChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e1d7068')) {
      api.createRecord('7e1d7068', component.options)
    } else {
      api.reload('7e1d7068', component.options)
    }
    module.hot.accept("./ReviewsFilterChip.vue?vue&type=template&id=7e1d7068&", function () {
      api.rerender('7e1d7068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewsFilter/components/ReviewsFilterChip.vue"
export default component.exports